import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../../input';
import { spacing } from '@sumup/circuit-ui/legacy';

const propagateChange = handler => e => {
	const { value } = e.target;

	return handler && handler(value);
};

const ZipCodeInput = ({ value, onChange, ...renderProps }) => {
	const { t } = useTranslation();
	return (
		<Input
			label={t('payment_method.credit_card.zip_code.title')}
			placeholder="•••••"
			value={value}
			maxLength="9"
			type="text"
			onChange={propagateChange(onChange)}
			autoComplete='postal-code'
			{...renderProps}
			css={spacing({ bottom: 'mega' })}
		/>
	);
};

export default ZipCodeInput;
